import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DxSelectBoxModule } from 'devextreme-angular';

import { Vm, SubTab, RequestItem, Kv } from '../../state/integration-tester.models';
import { ItBodyTabComponent } from './tabs/body-tab/it-body-tab.component';
import { ItParamsTabComponent } from './tabs/params-tab/it-params-tab.component';
import { ItHeadersTabComponent } from './tabs/headers-tab/it-headers-tab.component';

@Component({
  selector: 'it-editor',
  standalone: true,
  templateUrl: './it-editor.component.html',
  styleUrls: ['./it-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    AsyncPipe,
    FormsModule,
    DxSelectBoxModule,

    ItBodyTabComponent,
    ItParamsTabComponent,
    ItHeadersTabComponent,
  ],
})
export class ItEditorComponent {
  @Input({ required: true }) vm!: Vm;

  @Output() send = new EventEmitter<void>();
  @Output() updateRequest = new EventEmitter<Partial<RequestItem>>();
  @Output() setSubTab = new EventEmitter<SubTab>();

  // Params
  @Output() addParam = new EventEmitter<void>();
  @Output() updateParam = new EventEmitter<{ index: number; patch: Partial<Kv> }>();
  @Output() removeParam = new EventEmitter<{ index: number }>();
  @Output() clearParams = new EventEmitter<void>();

  // Headers
  @Output() addHeader = new EventEmitter<void>();
  @Output() addCommonHeaders = new EventEmitter<void>();
  @Output() updateHeader = new EventEmitter<{ index: number; patch: Partial<Kv> }>();
  @Output() removeHeader = new EventEmitter<{ index: number }>();
  @Output() clearHeaders = new EventEmitter<void>();

  // Body
  @Output() formatBody = new EventEmitter<void>();
  @Output() clearBody = new EventEmitter<void>();
}
